import React from "react";
import omitBy from "lodash/omitBy";
import { Text as NBText, Factory, ITextProps } from "native-base";
import {WithBaseStyles, WithHighlight} from "../hoc";

const textFactory = () => {
    return React.forwardRef((props: ITextProps, ref) => {
        const {
            color = "inherit",
            fontWeight = "inherit",
            whiteSpace = "inherit",
            textDecorationLine = "inherit",
        } = props;

        const componentProps ={
            ref, ...props, color,  fontWeight, whiteSpace, textDecorationLine
        }
        
        return <NBText { ...componentProps }   />
    })
}

export const Text = WithHighlight(textFactory(), ({ _text = {}, props}) => omitBy({ ...props, ..._text}, (value) => value === undefined)) as React.FC<ITextProps>

export const Small = WithBaseStyles(Text, {
    defaultProps: {
        fontSize: "sm",
    },
    baseStyle: {},
    variants: {}
})

export const Strong = WithBaseStyles(Text, {
    defaultProps: {
        fontWeight: "bold",
    },
    baseStyle: {},
    variants: {}
})